import react, { Component } from 'react';
import { DKLabel, DKButton, showToast, TOAST_TYPE, DKSpinner, DKCalendar, DKIcon, DKIcons, DKLine, DKInput, INPUT_VIEW_DIRECTION, Toggle } from "deskera-ui-library";
import date_range from "../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { saveAs } from 'file-saver';
import PayrollLiabilityGrid from '../reports/compliance/IN/PayrollLiabilityGrid';
import RouteManager from '../../managers/RouteManager';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import ReportService from '../../services/ReportService';
import { INPUT_TYPE } from '../../constants/Constant';
import SyncJEToBooksTable from './SyncJEToBooksTable';
import BooksIntegrationService from '../../services/BooksIntegrationService';
import Utility from '../../utility/Utility';
import { isMobileWebView } from '../../utility/ViewportSizeUtils';

export default class RevertJEPopup extends Component {
    data = []
    dateFormat = TenantService.get(TENANT.DATE_FORMAT);
    constructor(props) {
        super(props)
        this.state = {
            timePeriod: {
                toggle: false,
                startDate: moment().startOf('month'),
                endDate: moment().endOf("month"),
                defaultDate: false,
                hasError: false,
                errorMsg:'End date should not be less than Start date'
            },
            showReport: false,
            toggle: false
        }
    }
    generate = false;
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    getTimePeriod() {
        const dateFormat = TenantService.get(TENANT.DATE_FORMAT);
        const timePeriod = this.state.timePeriod
        return timePeriod.startDate && timePeriod.endDate ? `${moment(timePeriod.startDate).format(dateFormat)} - ${moment(timePeriod.endDate).format(dateFormat)}` : '';
    }
    export() {
        this.setState({ ...this.state })

        if (this.state.timePeriod.hasError) {
            return;
        }
        ReportService.apiConfig = {
            format: 'XLSX',
            fromDate: moment(this.state.timePeriod.startDate).format('YYYY-MM-DD'),
            toDate: moment(this.state.timePeriod.endDate).format('YYYY-MM-DD')


        }
        ReportService.exportLiabilityReport().then(
            (response) => {
                saveAs(response, `Payroll_Liability_Report_${this.getTimePeriod()}.xlsx`);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("No Record to export", TOAST_TYPE.FAILURE);
            }
        )
    }
    processBeforeSubmit(){
        let data = {revertPayrun:[]}
        let isInvalid = false;
        if(this.data.length != 0) {
            this.data.forEach(element=>{
                let obj ;
                if(element.jeRevertDate) {
                    
                    element.data.jeDetails.forEach(ele=>{
                        if(!ele.isRevertJE) {
                            obj = {
                                jeId: parseInt(ele.jeId),
                                jeRevertDate: moment(element.jeRevertDate).format('MM/DD/YYYY'),
                                payrunId: element.data._id
                            }
                        }
                    })
                    if(obj) {
                        data.revertPayrun.push(obj)
                    }
                    
                } else {
                    isInvalid = true;
                }
            })
            
        } else {
            showToast("Please select JE(s) to revert", TOAST_TYPE.WARNING);
            return;
        }
        if(isInvalid) {
            showToast("please select Date of Reversal Journal Entry", TOAST_TYPE.FAILURE);
            return;
        } else {
            return data;
        }
    }
    revert(){
        
        let param = this.processBeforeSubmit();
        if(param) {
            BooksIntegrationService.revert(param).then(response=>{
                console.log(response)
                showToast('JE(s) reverted successfully for given payrun(s)', TOAST_TYPE.SUCCESS);
                this.props.onClose();
            },
            error=>{
                console.log(error)
                showToast('Internal server error', TOAST_TYPE.FAILURE);
            })
        }
        
    }
    render() {
        return (
            <div className="popup-window" style={{ maxWidth: '70%',height:'70%'}}>
                <div className="row">
                    <DKLabel text=" Revert Entry to Deskera Books " className="fs-m fw-m align-self-center width-80" />
                    <div className="row-reverse ">
                        <DKButton
                            title="Revert"
                            className="border-m ml-r bg-app text-white"
                        onClick={() => this.revert()}
                        />
                        <DKButton
                            title="Cancel"
                            className="g-gray1 border-m"
                            onClick={(event) => {
                                this.props.onClose();
                            }}
                        />
                    </div>
                </div>
                <div className="p-v-m p-h-m">
                    <span>  The entries made in Deskera Books can be reverted.  </span>
                </div>
                <div className="bg-white pb-l mt-l web-width-40">
                    <div className="row row-responsive">
                        <div className="p-h-l parent-width " style={{ minWidth: "200px" }}>
                            <div >
                                {/* <div className="row">
                                    <DKInput
                                        title={"Filter by Pay Period"}
                                        type={INPUT_TYPE.TEXT}
                                        value={this.getTimePeriod()}
                                        required={true}
                                        readOnly={true}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    />
                                    <DKIcon
                                        className={`mr-s cursor-hand z-index-1 mt-xl pt-xs`}
                                        style={{
                                            marginLeft: "-30px",
                                            filter: "contrast(0.5)"

                                        }}
                                        src={date_range}
                                        onClick={() => {
                                            this.setState({
                                                timePeriod: {
                                                    toggle: true,
                                                    startDate: this.state.timePeriod.startDate,
                                                    endDate: this.state.timePeriod.endDate,
                                                    defaultDate: true,
                                                    hasError: false
                                                }
                                            })
                                        }}
                                    />
                                    {this.state.timePeriod.toggle && <DKCalendar
                                        className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
                                        style={{ top: 90, width: 65, "z-index": "1" }}
                                        isDateRange={true}
                                        selectedStartDate={this.state.timePeriod.startDate ? new Date(this.state.timePeriod.startDate) : new Date()}
                                        selectedEndDate={this.state.timePeriod.endDate ? new Date(this.state.timePeriod.endDate) : new Date()}
                                        onSelectDate={(start, end) => {
                                            
                                            let startDate = this.state.timePeriod.defaultDate
                                              ? start
                                              : this.state.timePeriod.startDate;
                                            let endDate = this.state.timePeriod.defaultDate
                                              ? this.state.timePeriod.endDate
                                              : end;
                                            if (
                                              !Utility.isEmpty(start) &&
                                              !Utility.isEmpty(end) &&
                                              moment(start).diff(end) <= 0
                                            ) {
                                              this.setState({
                                                timePeriod: {
                                                  toggle: false,
                                                  startDate: start,
                                                  endDate: end,
                                                  defaultDate: false,
                                                  hasError: false,
                                                },
                                              });
                                            } else if (moment(start).diff(end) > 0) {
                                              this.setState({
                                                timePeriod: {
                                                  toggle: this.state.timePeriod.defaultDate,
                                                  startDate: startDate,
                                                  endDate: endDate,
                                                  defaultDate: false,
                                                  hasError: true,
                                                  errorMsg:
                                                    "End date should not be less than Start date",
                                                },
                                              });
                                            }
                                          }}
                                        
                                    />}
                                </div> */}
                                
                                <div className="row row-responsive">
                                    <DKInput
                                        title={"Start date"}
                                        type={INPUT_TYPE.DATE}
                                        value={new Date(this.state.timePeriod.startDate)}
                                        required={true}
                                        readOnly={false}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        onChange={(value) => {
                                            let startDate =  value;
                                            let endDate = this.state.timePeriod.endDate
                                            if (
                                              !Utility.isEmpty(startDate) &&
                                              !Utility.isEmpty(endDate) &&
                                              moment(startDate).diff(endDate) <= 0
                                            ) {
                                            this.setState({
                                                timePeriod: {
                                                  toggle: false,
                                                  startDate: value,
                                                  endDate: this.state.timePeriod.endDate,
                                                  defaultDate: false,
                                                  hasError: false,
                                                },
                                              });
                                            } else {
                                                this.setState({
                                                    timePeriod: {
                                                      toggle: false,
                                                      startDate: value,
                                                      endDate: this.state.timePeriod.endDate,
                                                      defaultDate: false,
                                                      hasError: true,
                                                      errorMsg:'End date should not be less than Start date'
                                                    }
                                                  });
                                            }
                                        }}
                                    />
                                    <DKInput
                                        title={"End date"}
                                        type={INPUT_TYPE.DATE}
                                        value={new Date(this.state.timePeriod.endDate)}
                                        required={true}
                                        className={!isMobileWebView() ? `ml-l` :''}
                                        readOnly={false}
                                        canValidate={true}
                                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                        onChange={(value) => {
                                            let startDate =  this.state.timePeriod.startDate;
                                            let endDate = value
                                            if (
                                              !Utility.isEmpty(startDate) &&
                                              !Utility.isEmpty(endDate) &&
                                              moment(startDate).diff(endDate) <= 0
                                            ) {
                                            this.setState({
                                                timePeriod: {
                                                  toggle: false,
                                                  startDate: this.state.timePeriod.startDate,
                                                  endDate: value,
                                                  defaultDate: false,
                                                  hasError: false,
                                                }
                                              });
                                            } else {
                                                this.setState({
                                                    timePeriod: {
                                                      toggle: false,
                                                      startDate: this.state.timePeriod.startDate,
                                                      endDate: value,
                                                      defaultDate: false,
                                                      hasError: true,
                                                      errorMsg:'End date should not be less than Start date'
                                                    }
                                                  });
                                            }
                                        }}
                                    />
                                    </div>
                                    
                                    
                                
                            </div>

                        </div>

                        <div className="mb-xs ml-l" style={{ marginTop: '30px' }}>
                            <DKButton
                                title="Filter"
                                // icon={DKIcons.white.ic_export}
                                className="bg-app text-white"
                                onClick={() => {
                                    if(!this.state.timePeriod.hasError) {
                                        this.generate = !this.generate
                                        this.setState({
                                            ...this.state,
                                            showReport: true
                                        })
                                    }
                                }}
                            />
                            
                        </div>
                    </div>
                    {this.state.timePeriod.hasError && <DKLabel
                                        className="mt-xs text-red ml-l"
                                        text={this.state.timePeriod.errorMsg}
                                    />}
                </div>
                
                {this.state.showReport &&
                    <SyncJEToBooksTable
                        filter={
                            {
                                searchField: 'synced-by-pay-period',
                                searchString: `${moment(this.state.timePeriod.startDate).format('MM/DD/YYYY')}-${moment(this.state.timePeriod.endDate).format('MM/DD/YYYY')}`
                            }
                        }
                        isSync={false}
                        generate={this.generate}
                        selectedData={(row)=>{
                            this.data = row
                        }}
                    />}
            </div>
        )
    }
}

